"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSmoother = createSmoother;
var network_estimation_types_1 = require("../network-estimation-types");
var composite_smoother_1 = require("./composite-smoother");
var harmonic_mean_smoother_1 = require("./harmonic-mean-smoother");
var kama_smoother_1 = require("./kama-smoother");
var last_sample_smoother_1 = require("./last-sample-smoother");
var mean_smoother_1 = require("./mean-smoother");
var shaka_ewma_smoother_1 = require("./shaka-ewma-smoother");
function createSmoother(logger, smootherConfig, getValueForSmoothing, getDynamicMaxSampleAgeMs, getValueForWeighting) {
    switch (smootherConfig.type) {
        case network_estimation_types_1.SmootherType.LAST_SAMPLE:
            return new last_sample_smoother_1.LastSampleSmoother(getValueForSmoothing);
        case network_estimation_types_1.SmootherType.MEAN:
            return new mean_smoother_1.MeanSmoother(logger, getValueForSmoothing, getDynamicMaxSampleAgeMs, smootherConfig);
        case network_estimation_types_1.SmootherType.HARMONIC_MEAN:
            return new harmonic_mean_smoother_1.HarmonicMeanSmoother(logger, getValueForSmoothing, getDynamicMaxSampleAgeMs, smootherConfig);
        case network_estimation_types_1.SmootherType.KAMA:
            return new kama_smoother_1.KamaSmoother(logger, getValueForSmoothing, smootherConfig);
        case network_estimation_types_1.SmootherType.SHAKA_BASE_EWMA:
            return new shaka_ewma_smoother_1.ShakaEwmaBaseSmoother(getValueForSmoothing, smootherConfig, getValueForWeighting);
        case network_estimation_types_1.SmootherType.SHAKA_COMPOSITE_EWMA: {
            var config = (0, shaka_ewma_smoother_1.createShakaEwmaCompositeConfig)(smootherConfig);
            return createSmoother(logger, config, getValueForSmoothing, getDynamicMaxSampleAgeMs, getValueForWeighting);
        }
        case network_estimation_types_1.SmootherType.COMPOSITE: {
            var smoothers = smootherConfig.smootherConfigs.map(function (singleConfig) {
                return createSmoother(logger, singleConfig, getValueForSmoothing, getDynamicMaxSampleAgeMs, getValueForWeighting);
            });
            return new composite_smoother_1.CompositeSmoother(smoothers, smootherConfig.composerType);
        }
    }
}
